import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Input,OnDestroy } from '@angular/core';
import { WbService } from '../wb.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { WhiteBoardComponent } from "../white-board.component";
import { SessionManagerService } from "../services/session/session-manager.service";
import { RecordingManagerService } from "../services/recording/recording-manager.service";
import { LayoutManagerService } from "../services/layout/layout-manager.service";
import {LogService} from "../services/log/log.service";

import { WsService2 } from '../services/ws/ws.service';
import { RoomManagerService } from "../services/room/room-manager.service";
import { ChatParserService } from "../services/chat/chat-parser.service";
import { IChatManager } from "../services/chat/chat-manager";
import { PermissionsManagerService } from "../services/permissions/permissions-manager.service";
declare var $;
declare var MQ;
declare var MathQuill;
@Component({
  selector: "dskl-wb-chat",
  templateUrl: './chat-wb.component.html',
 // styleUrls: ["algebra.css"],
  inputs: ["board"],
  outputs: ["change"], 
  
})

export class ChatWbComponent extends WhiteBoardComponent implements IChatManager, OnDestroy{

  rows = [];
  currentRow = 0;
 
  onCurrentPageState(state, pageId) {
    
  }

  onReady() {
   
  }
 
  getWbType() {
    return this.pageName;
  }
  pageName = "chat";
 
  constructor(protected log: LogService, protected wbService: WbService, private translate: TranslateService, protected sessionManager: SessionManagerService, protected layoutManagerService: LayoutManagerService, protected permissionsManager: PermissionsManagerService,private chatParser: ChatParserService, private wsService: WsService2, private roomManagerService: RoomManagerService,) {
    super(log, wbService, sessionManager, layoutManagerService, permissionsManager);
chatParser.setChatManager(this);  
wbService.setShowChat(false);
}
onDestroy(){
  this.wbService.setShowChat(true);
}
  onUpdate(){
  
  }
  onResize() {

  }
  onViewReady() {
   

  }
 
  onState(state, pageId) {
   
  }
 toggle = "in";

  chatMessages = 0;
  notMe(k) {

    return k != this.wsService.getMe()
  }
  peerKeys() {
    return Object.keys(this.roomManagerService.peers);
  }
  peers(k) {
    return this.roomManagerService.peers[k];
  }
  to() {

    console.log(this.toggle)
    this.toggle = this.toggle == 'in' ? 'out' : 'in'
  }
  sendMessage(msg) {
    this.chatParser.sendMessage(msg, this.currentSender);
    $("#messages").animate({ scrollTop: $('#messages').prop("scrollHeight") }, 200);

  }

  static ROOM_SENDER = "all"
  currentSender = ChatWbComponent.ROOM_SENDER;
  last;
  currentName() {
    if (this.currentSender == ChatWbComponent.ROOM_SENDER) {
      return "";

    } else {
      return this.peers(this.currentSender).name;
    }
  }
  onMessage(from, name, message, me, isPrivate) {
    this.last = from;
    var key;
    if (!isPrivate) {
      key = ChatWbComponent.ROOM_SENDER;
    } else {
      if (!me)
        key = from;
      else key = this.currentSender
    }
    if (!this.messages[key])
      this.messages[key] = [];
    this.messages[key].push({ name: name, msg: message, me: me });

    if (!me && this.toggle != "in") {
      this.to()
    }
    if (key == this.currentSender)
      $("#messages").animate({ scrollTop: $('#messages').prop("scrollHeight") }, 200);
    else {
      if (key == "all") {
        this.chatMessages++;
      } else {
        if (!this.roomManagerService.peers[key].chatMessages)
          this.roomManagerService.peers[key].chatMessages = 0;
        this.roomManagerService.peers[key].chatMessages++;
      }
    }
  }

  selected(p) {
    this.currentSender = p;
    if (p == "all")
      this.chatMessages = 0;
    else
      this.roomManagerService.peers[p]["chatMessages"] = 0;
    
    setTimeout(function() {
      $("#messages").animate({ scrollTop: $('#messages').prop("scrollHeight") }, 200);
    }, 100);

  }
  hasLinks(msg) {
    return /(https?:\/\/[^\s]+)/g.test(msg);
  }

  findUrls(message) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    return message.replace(urlRegex, function (url) {
      return '<a target="_blank" class="chat-link" style="color:white;" href="' + url + '">' + url + '</a>';
    })
    // or alternatively
    // return text.replace(urlRegex, '<a href="$1">$1</a>')
  }

  messages = { all: [] };
}



// WEBPACK FOOTER //
// /app/src/app/wb/chatwb/chat-wb.component.ts